function fullcopy(data) {
  let copy = JSON.parse(JSON.stringify(data));

  return copy;
}

export default fullcopy;
